/* Dermatinta · tema de campaña · lógica
   Precios, variantes y disponibilidad vienen del HTML que pinta Shopify (data-*). El carrito es el real:
   API Ajax (/cart/add.js, /cart/change.js, /cart.js) y el pago es el checkout de Shopify.
   Sin dependencias. Si este archivo no carga, el formulario agrega al carrito igual (envío normal a /cart/add). */
(function () {
  'use strict';
  var DT = window.DT || {};
  var doc = document.documentElement;
  var MAXQ = DT.cantidadMax || 10;
  var R = DT.rutas || { carrito: '/cart', agregar: '/cart/add', cambiar: '/cart/change', raiz: '/' };
  var T = DT.textos || {};

  /* ---------- utilidades ---------- */
  function $(s, r) { return (r || document).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
  function esc(t) { return String(t == null ? '' : t).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function setText(el, t) { if (el && el.textContent !== t) el.textContent = t; }
  function clampQ(n) { n = parseInt(n, 10); if (isNaN(n) || n < 1) n = 1; return Math.min(n, Math.max(1, +DT.cantidadMax || MAXQ)); }
  function suave() { return (window.DTMotion ? window.DTMotion.quiet() : matchMedia('(prefers-reduced-motion: reduce)').matches) ? 'auto' : 'smooth'; }

  /* Formato de dinero de la tienda (shop.money_format), igual que Shopify. */
  function dinero(centavos) {
    var formato = DT.formato || '${{amount_no_decimals_with_comma_separator}}';
    centavos = parseInt(centavos, 10) || 0;
    function sep(n, dec, miles, decimal) {
      var fijo = (n / 100).toFixed(dec).split('.');
      var ent = fijo[0].replace(/\B(?=(\d{3})+(?!\d))/g, miles);
      return ent + (fijo[1] ? decimal + fijo[1] : '');
    }
    return formato.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, k) {
      switch (k) {
        case 'amount': return sep(centavos, 2, ',', '.');
        case 'amount_no_decimals': return sep(centavos, 0, ',', '.');
        case 'amount_with_comma_separator': return sep(centavos, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return sep(centavos, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return sep(centavos, 2, "'", '.');
        case 'amount_no_decimals_with_space_separator': return sep(centavos, 0, ' ', ',');
        case 'amount_with_space_separator': return sep(centavos, 2, ' ', ',');
        default: return sep(centavos, 0, '.', ',');
      }
    });
  }

  function pedir(url, datos) {
    return fetch(url, {
      method: datos ? 'POST' : 'GET',
      headers: datos ? { 'Content-Type': 'application/json', 'Accept': 'application/json' } : { 'Accept': 'application/json' },
      body: datos ? JSON.stringify(datos) : undefined,
      credentials: 'same-origin'
    }).then(function (r) {
      return r.json().then(function (j) {
        if (!r.ok) { var e = new Error(j.description || j.message || T.error); e.datos = j; throw e; }
        return j;
      });
    });
  }

  /* ---------- oferta: opciones, galería, cantidad ---------- */
  var caja = $('[data-comprar]');
  var form = caja ? $('[data-form-compra]', caja) : null;
  var estado = { qty: 1 };
  var agregando = false, compraListeners = [], focoCompra = 0;
  function onCompra(el, ev, fn) { el.addEventListener(ev, fn); compraListeners.push([el, ev, fn]); }
  var OFERTA = {}; // kit|crema|espuma → { variante, precio, nombre }

  function radios() { return form ? $$('input[type="radio"][name^="variante-"]', form) : []; }
  radios().forEach(function (r) {
    OFERTA[r.value] = { variante: String(r.getAttribute('data-variante')), precio: +r.getAttribute('data-precio'), nombre: r.getAttribute('data-nombre'), disponible: !r.disabled };
  });
  function seleccionada() {
    var r = form && $('input[type="radio"][name^="variante-"]:checked', form);
    if (!r) { r = radios().filter(function (x) { return !x.disabled; })[0]; if (r) r.checked = true; }
    return r;
  }

  var mainPic = caja ? $('[data-main]', caja) : null;
  function verFoto(clave) {
    if (!mainPic || !clave) return;
    var t = $('.thumb[data-img="' + clave + '"]', caja);
    if (!t) return;
    var img = $('img', mainPic), src = $('source', mainPic);
    if (src) { src.srcset = t.getAttribute('data-srcset'); }
    else { img.srcset = t.getAttribute('data-srcset'); img.sizes = '(min-width: 900px) 540px, 92vw'; }
    img.src = t.getAttribute('data-src');
    img.alt = t.getAttribute('data-alt') || '';
    img.removeAttribute('width'); img.removeAttribute('height');
    $$('.thumb', caja).forEach(function (x) { x.setAttribute('aria-pressed', x === t ? 'true' : 'false'); });
  }


  var qtyIn = form ? $('[data-qty-input]', form) : null;
  var btnAgregar = form ? $('[data-agregar]', form) : null;
  function textoBoton(id) {
    if (id === 'kit') return 'Agregar el kit';
    if (id === 'crema') return 'Agregar la crema';
    if (id === 'espuma') return 'Agregar la espuma';
    return btnAgregar ? btnAgregar.getAttribute('data-texto') || btnAgregar.textContent : '';
  }
  if (btnAgregar) btnAgregar.setAttribute('data-texto', btnAgregar.textContent);

  function pintarSeleccion() {
    var r = seleccionada();
    if (!r) { if (btnAgregar) { btnAgregar.disabled = true; setText(btnAgregar, T.agotado || 'Agotado'); } return; }
    var precio = +r.getAttribute('data-precio');
    estado.qty = clampQ(estado.qty);
    var requierePlan = r.getAttribute('data-requiere-plan') === 'true';
    // Fallback único: faltan condiciones contractuales verificadas, incluso si hay asignaciones.
    var plan = $('[data-plan-input]', form), tipos = $('[data-compra-tipo]', form);
    if (plan) { plan.disabled = true; plan.value = ''; }
    if (tipos) { tipos.hidden = true; $$('input', tipos).forEach(function (t) { t.disabled = true; }); }
    $('[data-variante-id]', form).value = r.getAttribute('data-variante');
    $('[data-variante-id]', form).disabled = false;
    $$('[data-precio-sel]').forEach(function (el) { setText(el, dinero(precio * estado.qty)); });
    setText($('[data-est-sub]', caja), dinero(precio * estado.qty));
    $$('[data-resumen-u]').forEach(function (el) { setText(el, estado.qty > 1 ? 'total' : 'c/u'); });
    $$('input[name^="pack-"]', form).forEach(function (p) {
      p.checked = +p.value === estado.qty; p.disabled = +p.value > Math.max(1, +DT.cantidadMax || MAXQ);
      setText($('[data-pack-precio="' + p.value + '"]', form), dinero(precio * +p.value));
      var antes = $('[data-pack-antes="' + p.value + '"]', form); if (antes) { antes.hidden = true; antes.textContent = ''; }
    });
    var ahorro = $('[data-fila-ahorro]', caja); if (ahorro) ahorro.hidden = true;
    btnAgregar.disabled = agregando || requierePlan || r.disabled;
    setText(btnAgregar, r.disabled ? (T.agotado || 'Agotado') : (requierePlan ? 'Compra única no disponible' : textoBoton(r.value)));
    var nombre = r.getAttribute('data-nombre');
    var sn = $('[data-sticky-nombre]'); if (sn) setText(sn, nombre + (estado.qty > 1 ? ' × ' + estado.qty : ''));
    var sb = $('[data-agregar-sticky]'); if (sb) { sb.disabled = btnAgregar.disabled; setText(sb, requierePlan ? 'No disponible' : textoBoton(r.value)); sb.setAttribute('aria-label', 'Agregar ' + (estado.qty > 1 ? estado.qty + ' × ' : '') + nombre + ' al carrito'); }
    qtyIn.value = estado.qty;
    setText($('[data-oferta-aviso]', form), requierePlan ? 'Este producto no está disponible para compra única. Escríbenos y te ayudamos.' : 'Pagas una sola vez. Sin suscripción.');
  }
  function elegir(id, mover) {
    if (!form) return;
    var r = $('input[type="radio"][name^="variante-"][value="' + id + '"]', form);
    if (r && (!r.disabled || (id === 'espuma' && doc.getAttribute('data-perfil') === 'reciente'))) { r.checked = true; verFoto(r.getAttribute('data-foto')); }
    pintarSeleccion();
    if (mover && caja) {
      caja.scrollIntoView({ behavior: suave() });
      clearTimeout(focoCompra); focoCompra = setTimeout(function () { var x = seleccionada(); if (x && x.isConnected) x.focus({ preventScroll: true }); }, 450);
    }
  }
  function montarCompra() {
    compraListeners.forEach(function (l) { l[0].removeEventListener(l[1], l[2]); }); compraListeners = []; clearTimeout(focoCompra);
    caja = $('[data-comprar]'); form = caja ? $('[data-form-compra]', caja) : null;
    mainPic = caja ? $('[data-main]', caja) : null;
    qtyIn = form ? $('[data-qty-input]', form) : null; btnAgregar = form ? $('[data-agregar]', form) : null;
    if (!form) return;
    estado.qty = clampQ(qtyIn.value); OFERTA = {};
    radios().forEach(function (r) { OFERTA[r.value] = { variante: String(r.getAttribute('data-variante')), precio: +r.getAttribute('data-precio'), nombre: r.getAttribute('data-nombre'), disponible: !r.disabled && r.getAttribute('data-requiere-plan') !== 'true' }; });
    $$('.thumb', caja).forEach(function (t) { onCompra(t, 'click', function () { verFoto(t.getAttribute('data-img')); }); });
    var packs = $('[data-pack]', form); if (packs) packs.hidden = false;
    onCompra(form, 'change', function (e) {
      if (e.target.name && e.target.name.indexOf('variante-') === 0) { verFoto(e.target.getAttribute('data-foto')); pintarSeleccion(); }
      if (e.target.name && e.target.name.indexOf('pack-') === 0) { estado.qty = clampQ(e.target.value); pintarSeleccion(); }
    });
    $$('[data-qty]', form).forEach(function (b) { onCompra(b, 'click', function () { estado.qty = clampQ(estado.qty + parseInt(b.getAttribute('data-qty'), 10)); pintarSeleccion(); }); });
    qtyIn.max = MAXQ;
    onCompra(qtyIn, 'change', function () { estado.qty = clampQ(qtyIn.value); pintarSeleccion(); });
    onCompra(form, 'submit', function (e) { e.preventDefault(); agregarSeleccion(btnAgregar); });
    pintarSeleccion();
  }

  /* ---------- selector «tu tatuaje hoy» ---------- */
  $$('input[type="radio"][name^="momento-"]').forEach(function (r) {
    r.addEventListener('change', function () {
      var sec = r.closest('section');
      $$('[data-panel]', sec).forEach(function (p) { p.hidden = p.getAttribute('data-panel') !== r.value; });
    });
  });
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('button[data-elegir]');
    if (b) elegir(b.getAttribute('data-elegir'), true);
    var a = e.target.closest && e.target.closest('[data-ir-comprar]');
    if (!a || !caja || (a.getAttribute('href') || '').charAt(0) !== '#') return;
    e.preventDefault(); var r = seleccionada(); elegir(r ? r.value : '', true);
  });
  window.DTCompra = { elegir: elegir, pintar: pintarSeleccion };

  /* ---------- carrito real ---------- */
  var cajaCarrito = $('#carrito'), velo = $('[data-velo]');
  var lista = $('[data-cart-lista]'), vacio = $('[data-cart-vacio]'), live = $('[data-cart-live]');
  var upsell = $('[data-upsell]'), btnPagar = $('[data-pagar]'), errCarrito = $('[data-cart-error]');
  var carrito = null, abridor = null;
  try { carrito = JSON.parse(($('[data-cart-json]') || {}).textContent || 'null'); } catch (e) { carrito = null; }

  function anunciar(t) { if (!live) return; live.textContent = ''; setTimeout(function () { live.textContent = t; }, 60); }
  function enCarrito(variante) {
    if (!carrito || !variante) return 0;
    return carrito.items.reduce(function (s, it) { return s + (String(it.variant_id) === String(variante) ? it.quantity : 0); }, 0);
  }
  function imgPeq(u) { if (!u) return ''; return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=160'; }

  function pintarCarrito() {
    if (!cajaCarrito || !carrito) return;
    lista.innerHTML = '';
    carrito.items.forEach(function (it, i) {
      var li = document.createElement('li');
      var linea = i + 1;
      var variante = it.variant_title && it.variant_title !== 'Default Title' ? '<p class="linea__inc">' + esc(it.variant_title) + '</p>' : '';
      li.className = 'linea';
      li.innerHTML =
        (it.image ? '<img src="' + esc(imgPeq(it.image)) + '" width="56" height="68" alt="" loading="lazy">' : '<span></span>') +
        '<div>' +
          '<div class="linea__top"><a href="' + esc(it.url) + '">' + esc(it.product_title) + '</a><span>' + dinero(it.final_line_price) + '</span></div>' +
          variante + (it.selling_plan_allocation ? '<p class="linea__inc">Suscripción: ' + esc(it.selling_plan_allocation.selling_plan.name) + '</p>' : '<p class="linea__inc">Compra única</p>') +
          '<p class="linea__inc">' + dinero(it.final_price) + ' c/u</p>' +
          '<div class="linea__ctl">' +
            '<div class="qty" role="group" aria-label="Cantidad de ' + esc(it.product_title) + '">' +
              '<button type="button" class="qty__b" data-linea="' + linea + '" data-d="-1" aria-label="Quitar una unidad de ' + esc(it.product_title) + '"' + (it.quantity <= 1 ? ' disabled' : '') + '>−</button>' +
              '<input class="qty__n" type="number" min="1" max="' + MAXQ + '" value="' + it.quantity + '" aria-label="Cantidad de ' + esc(it.product_title) + '" data-linea-in="' + linea + '">' +
              '<button type="button" class="qty__b" data-linea="' + linea + '" data-d="1" aria-label="Agregar una unidad de ' + esc(it.product_title) + '"' + (it.quantity >= MAXQ ? ' disabled' : '') + '>+</button>' +
            '</div>' +
            '<button type="button" class="linea__quitar" data-quitar="' + linea + '">' + esc(T.quitar || 'Quitar') + '</button>' +
          '</div>' +
        '</div>';
      li.setAttribute('data-q', it.quantity);
      lista.appendChild(li);
    });
    vacio.hidden = carrito.items.length > 0;
    setText($('[data-cart-sub]'), dinero(carrito.total_price));
    var ahorroCarrito = $('[data-cart-ahorro]');
    if (ahorroCarrito) {
      ahorroCarrito.hidden = !(carrito.total_discount > 0);
      setText(ahorroCarrito, carrito.total_discount > 0 ? 'Descuento aplicado: ahorras ' + dinero(carrito.total_discount) + '.' : '');
    }
    if (btnPagar) btnPagar.hidden = carrito.items.length === 0;

    // El paso que falta, a precio normal. Nunca se agrega solo.
    var sugerido = null;
    if (DT.upsell && doc.getAttribute('data-perfil') !== 'reciente' && OFERTA.crema && OFERTA.espuma && !enCarrito(OFERTA.kit && OFERTA.kit.variante)) {
      var c = enCarrito(OFERTA.crema.variante), s = enCarrito(OFERTA.espuma.variante);
      if (c && !s && OFERTA.espuma.disponible) sugerido = 'espuma';
      else if (s && !c && OFERTA.crema.disponible) sugerido = 'crema';
    }
    if (sugerido && upsell) {
      var o = OFERTA[sugerido];
      upsell.innerHTML = '<p><b>' + (sugerido === 'espuma' ? '¿Te falta el paso 1?' : '¿Te falta el paso 2?') + '</b> ' +
        (sugerido === 'espuma' ? 'La espuma limpia suave antes de hidratar.' : 'La crema hidrata después de limpiar.') + '</p>' +
        '<div class="upsell__row"><span>' + esc(o.nombre) + ' · ' + dinero(o.precio) + '</span>' +
        '<button type="button" class="upsell__btn" data-sumar="' + esc(o.variante) + '">Agregar</button></div>';
      upsell.hidden = false;
    } else if (upsell) { upsell.hidden = true; upsell.innerHTML = ''; }

    var n = carrito.item_count;
    $$('[data-cart-count]').forEach(function (cnt) { cnt.textContent = n; cnt.hidden = n === 0; });
    $$('[data-abrir-carrito]').forEach(function (a) { a.setAttribute('aria-label', 'Abrir carrito, ' + n + (n === 1 ? ' producto' : ' productos')); });
  }
  function mostrarError(el, msg) { if (!el) return; el.textContent = msg || T.error; el.hidden = false; }
  function limpiarError(el) { if (el) { el.hidden = true; el.textContent = ''; } }
  function refrescar() { return pedir(R.carrito + '.js').then(function (c) { carrito = c; pintarCarrito(); return c; }); }

  function agregarVariante(variante, q, desde, plan) {
    if (agregando) return Promise.resolve();
    agregando = true; pintarSeleccion();
    var errForm = form ? $('[data-error-compra]', form) : null;
    limpiarError(errForm); limpiarError(errCarrito);
    if (desde) desde.setAttribute('aria-busy', 'true');
    var item = { id: +variante, quantity: q };
    if (plan) item.selling_plan = +plan;  // 16-oct: suscripción (plan de la app Shopify Subscriptions)
    var agregado = false;
    return pedir(R.agregar + '.js', { items: [item] })
      .then(function (r) { agregado = true; return refrescar().then(function () { return r; }); })
      .then(function (r) {
        var nombre = r.items && r.items[0] ? r.items[0].product_title : '';
        anunciar('Agregaste ' + q + ' × ' + nombre + '. Subtotal ' + dinero(carrito.total_price) + '.');
        if (DT.lateral === false || !cajaCarrito) { location.href = R.carrito; return; }
        if (cajaCarrito.hidden) abrirCarrito(desde);
      })
      .catch(function (e) { mostrarError(cajaCarrito && !cajaCarrito.hidden ? errCarrito : errForm, agregado ? 'El producto se agregó, pero no se pudo actualizar el resumen. Revisa el carrito antes de volver a agregar.' : (e.datos ? e.message : T.error)); })
      .then(function () { agregando = false; if (desde) desde.removeAttribute('aria-busy'); pintarSeleccion(); });
  }
  function agregarSeleccion(desde) {
    var r = seleccionada(); if (!r || r.disabled || agregando || r.getAttribute('data-requiere-plan') === 'true') return;
    var plan = form ? $('[data-plan-input]', form) : null;
    agregarVariante(r.getAttribute('data-variante'), estado.qty, desde, plan && !plan.disabled ? plan.value : '');
  }
  function cambiarLinea(linea, q) {
    limpiarError(errCarrito);
    return pedir(R.cambiar + '.js', { line: +linea, quantity: q })
      .then(function (c) { carrito = c; pintarCarrito(); return c; })
      .catch(function (e) { mostrarError(errCarrito, e.message); refrescar(); });
  }

  function focoInterno() { return $$('button, [href], input, [tabindex]:not([tabindex="-1"])', cajaCarrito).filter(function (e) { return !e.disabled && e.offsetParent !== null; }); }
  function abrirCarrito(desde) {
    if (!cajaCarrito) return;
    abridor = desde || document.activeElement;
    cajaCarrito.hidden = false; velo.hidden = false;
    doc.classList.add('carrito-abierto');
    $$('body > *:not(.carrito):not(.velo):not(script):not(svg)').forEach(function (el) { el.setAttribute('inert', ''); el.setAttribute('data-inert-carrito', ''); });
    setTimeout(function () { $('[data-cerrar-carrito]').focus(); }, 30);
  }
  function cerrarCarrito() {
    cajaCarrito.hidden = true; velo.hidden = true;
    doc.classList.remove('carrito-abierto');
    $$('[data-inert-carrito]').forEach(function (el) { el.removeAttribute('inert'); el.removeAttribute('data-inert-carrito'); });
    actualizarSticky();
    if (abridor && abridor.focus) abridor.focus();
  }

  if (cajaCarrito) {
    $$('[data-abrir-carrito]').forEach(function (a) {
      a.addEventListener('click', function (e) {
        if (DT.lateral === false) return;
        e.preventDefault(); abrirCarrito(e.currentTarget); refrescar().catch(function () {});
      });
    });
    $('[data-cerrar-carrito]').addEventListener('click', cerrarCarrito);
    velo.addEventListener('click', cerrarCarrito);
    document.addEventListener('keydown', function (e) {
      if (cajaCarrito.hidden) return;
      if (e.key === 'Escape') { cerrarCarrito(); return; }
      if (e.key === 'Tab') {
        var f = focoInterno(); if (!f.length) return;
        var a = f[0], z = f[f.length - 1];
        if (e.shiftKey && document.activeElement === a) { e.preventDefault(); z.focus(); }
        else if (!e.shiftKey && document.activeElement === z) { e.preventDefault(); a.focus(); }
      }
    });
    cajaCarrito.addEventListener('click', function (e) {
      var b = e.target.closest('button'); if (!b || b.disabled) return;
      if (b.hasAttribute('data-linea')) {
        var linea = b.getAttribute('data-linea'), d = parseInt(b.getAttribute('data-d'), 10);
        var actual = carrito.items[linea - 1] ? carrito.items[linea - 1].quantity : 1;
        var q = Math.max(1, Math.min(MAXQ, actual + d));
        cambiarLinea(linea, q).then(function () {
          anunciar((carrito.items[linea - 1] ? carrito.items[linea - 1].product_title + ': ' + q + '. ' : '') + 'Subtotal ' + dinero(carrito.total_price) + '.');
          var again = $('[data-linea="' + linea + '"][data-d="' + d + '"]'); if (again && !again.disabled) again.focus();
        });
      } else if (b.hasAttribute('data-quitar')) {
        var l = b.getAttribute('data-quitar');
        var nombre = carrito.items[l - 1] ? carrito.items[l - 1].product_title : '';
        cambiarLinea(l, 0).then(function () { anunciar('Quitaste ' + nombre + '.'); $('[data-cerrar-carrito]').focus(); });
      } else if (b.hasAttribute('data-sumar')) {
        agregarVariante(b.getAttribute('data-sumar'), 1, null).then(function () { $('[data-cerrar-carrito]').focus(); });
      }
    });
    cajaCarrito.addEventListener('change', function (e) {
      var linea = e.target.getAttribute('data-linea-in'); if (!linea) return;
      cambiarLinea(linea, clampQ(e.target.value));
    });
  }

  /* ---------- barra fija móvil ---------- */
  var sticky = $('[data-sticky]');
  var visibles = new Set();
  var heroPasado = false;
  function actualizarSticky() {
    if (!sticky) return;
    var movil = matchMedia('(max-width: 899px)').matches || sticky.classList.contains('sticky--kit');  // 16-oct: la barra con el kit también en computador
    var on = movil && heroPasado && visibles.size === 0 && (!cajaCarrito || cajaCarrito.hidden) && !!seleccionada();
    sticky.classList.toggle('is-on', on);
    sticky.setAttribute('aria-hidden', on ? 'false' : 'true');
    if (on) sticky.removeAttribute('inert'); else sticky.setAttribute('inert', '');
    doc.style.setProperty('--sticky-h', on ? sticky.offsetHeight + 'px' : '0px');
    doc.style.setProperty('--pad-sticky', movil ? (sticky.offsetHeight || 72) + 'px' : '0px');
  }
  var stickyObservers = [], stickyTargets = new Set(), stickyHero = null;
  document.addEventListener('click', function (e) { var b = e.target.closest && e.target.closest('[data-agregar-sticky]'); if (b && !b.disabled) agregarSeleccion(b); });
  function montarSticky() {
    stickyObservers.forEach(function (io) { io.disconnect(); }); stickyObservers = []; visibles.clear(); stickyTargets.clear(); stickyHero = null;
    sticky = $('[data-sticky]'); if (!sticky) return;
    if ('IntersectionObserver' in window) {
      stickyHero = $('#inicio');
      var io = new IntersectionObserver(function (ents) {
        ents.forEach(function (en) { if (stickyTargets.has(en.target) && en.target.isConnected && en.isIntersecting) visibles.add(en.target); else visibles.delete(en.target); });
        actualizarSticky();
      });
      $$('[data-oculta-sticky]').forEach(function (el) { stickyTargets.add(el); io.observe(el); });
      stickyObservers.push(io);
      if (stickyHero) { var hi = new IntersectionObserver(function (ents) { if (stickyHero && stickyHero.isConnected && ents[0].target === stickyHero) { heroPasado = !ents[0].isIntersecting; actualizarSticky(); } }, { threshold: 0 }); hi.observe(stickyHero); stickyObservers.push(hi); }
      else heroPasado = true;
    }
    actualizarSticky();
  }
  addEventListener('resize', actualizarSticky);
  document.addEventListener('shopify:section:load', function () { montarCompra(); montarSticky(); });
  document.addEventListener('shopify:section:unload', function (e) {
    if (caja && e.target.contains(caja)) {
      compraListeners.forEach(function (l) { l[0].removeEventListener(l[1], l[2]); }); compraListeners = []; clearTimeout(focoCompra);
      caja = null; form = null; qtyIn = null; btnAgregar = null;
    }
    // Unload ocurre antes de retirar el DOM: no remontar ni reobservar esa sección.
    stickyTargets.forEach(function (el) {
      if (e.target.contains(el)) { stickyObservers[0].unobserve(el); stickyTargets.delete(el); visibles.delete(el); }
    });
    if (stickyHero && e.target.contains(stickyHero)) {
      stickyObservers.pop().disconnect(); stickyHero = null; heroPasado = true;
    }
    if (sticky && e.target.contains(sticky)) {
      stickyObservers.forEach(function (io) { io.disconnect(); }); stickyObservers = []; stickyTargets.clear(); visibles.clear(); stickyHero = null;
      sticky.classList.remove('is-on'); sticky.setAttribute('aria-hidden', 'true'); sticky.setAttribute('inert', ''); sticky = null;
      doc.style.setProperty('--sticky-h', '0px'); doc.style.setProperty('--pad-sticky', '0px');
    }
    actualizarSticky();
  });

  /* ---------- ficha de producto y formularios simples: agregar con el carrito real ---------- */
  $$('form[data-form-ajax]').forEach(function (f) {
    var q = $('input[name="quantity"]', f), btn = $('button[type="submit"]', f);
    $$('[data-qty-ajax]', f).forEach(function (b) {
      b.addEventListener('click', function () { q.value = clampQ(+q.value + parseInt(b.getAttribute('data-qty-ajax'), 10)); });
    });
    q.addEventListener('change', function () { q.value = clampQ(q.value); });
    var enviando = false;
    f.addEventListener('submit', function (e) {
      e.preventDefault();
      if (enviando) return;
      enviando = true;
      var err = $('[data-error-compra]', f); limpiarError(err);
      if (btn) { btn.setAttribute('aria-busy', 'true'); btn.disabled = true; }
      pedir(R.agregar + '.js', { items: [{ id: +$('input[name="id"]', f).value, quantity: clampQ(q.value) }] })
        .then(function () { return refrescar(); })
        .then(function () {
          anunciar('Agregado al carrito. Subtotal ' + dinero(carrito.total_price) + '.');
          if (DT.lateral === false || !cajaCarrito) { location.href = R.carrito; return; }
          abrirCarrito(btn);
        })
        .catch(function (e2) { mostrarError(err, e2.datos ? e2.message : T.error); })
        .then(function () { enviando = false; if (btn) { btn.removeAttribute('aria-busy'); btn.disabled = false; } });
    });
  });
/* Galerías por instancia: imagen completa, texto alternativo, leyenda, teclado y editor. */
  var galeriasPdp = new Map();
  function iniciarGaleriaPdp(galeria) {
    if (galeriasPdp.has(galeria)) return;
    var main = galeria.querySelector('.pdp__principal img');
    if (!main) return;
    var rotulo = galeria.querySelector('[data-pdp-rotulo]');
    var caption = galeria.querySelector('[data-pdp-caption]');
    var video = galeria.querySelector('[data-pdp-video]');
    var videoShell = galeria.querySelector('[data-pdp-video-shell]');
    var botones = Array.prototype.slice.call(galeria.querySelectorAll('[data-pdp-thumb]'));
    var listeners = [];
    function elegirFoto(i, foco) {
      var boton = botones[i]; if (!boton) return;
      main.srcset = boton.getAttribute('data-srcset') || '';
      main.src = boton.getAttribute('data-src');
      main.alt = boton.getAttribute('data-alt') || '';
      main.style.objectPosition = boton.getAttribute('data-pos') || '';
      var videoUrl = boton.getAttribute('data-video-url') || '';
      var esVideo = !!(videoUrl && video && videoShell);
      main.hidden = esVideo;
      if (video && videoShell) {
        video.pause(); videoShell.hidden = !esVideo;
        video.setAttribute('data-gallery-active', String(esVideo));
        if (esVideo) {
          if (videoUrl !== video.getAttribute('data-src') && video.hasAttribute('src')) video.removeAttribute('src');
          video.setAttribute('data-src', videoUrl); video.poster = boton.getAttribute('data-src');
          video.setAttribute('aria-label', main.alt);
        }
        if (window.DTVideos) window.DTVideos.refresh();
      }
      if (caption) caption.textContent = main.alt;
      if (rotulo) { var texto=boton.getAttribute('data-rotulo') || ''; rotulo.textContent=texto; rotulo.hidden=!texto; }
      botones.forEach(function (b) { b.setAttribute('aria-pressed',String(b===boton)); });
      if (foco) boton.focus();
    }
    botones.forEach(function (boton,i) {
      var click = function () { elegirFoto(i,false); };
      var teclado = function (e) {
        var siguiente;
        if (e.key==='ArrowRight') siguiente=(i+1)%botones.length;
        else if (e.key==='ArrowLeft') siguiente=(i+botones.length-1)%botones.length;
        else if (e.key==='Home') siguiente=0;
        else if (e.key==='End') siguiente=botones.length-1;
        else return;
        e.preventDefault(); elegirFoto(siguiente,true);
      };
      boton.addEventListener('click',click); boton.addEventListener('keydown',teclado);
      listeners.push([boton,'click',click],[boton,'keydown',teclado]);
    });
    galeriasPdp.set(galeria,function () { listeners.forEach(function (l) { l[0].removeEventListener(l[1],l[2]); }); galeriasPdp.delete(galeria); });
  }
  function recorrerGaleriasPdp(root,fn) {
    if (!root || !root.querySelectorAll) return;
    if (root.matches && root.matches('[data-pdp-galeria]')) fn(root);
    Array.prototype.forEach.call(root.querySelectorAll('[data-pdp-galeria]'),fn);
  }
  recorrerGaleriasPdp(document,iniciarGaleriaPdp);
  document.addEventListener('shopify:section:load',function (e) { recorrerGaleriasPdp(e.target,iniciarGaleriaPdp); });
  document.addEventListener('shopify:section:unload',function (e) { recorrerGaleriasPdp(e.target,function (g) { var limpiar=galeriasPdp.get(g); if(limpiar) limpiar(); }); });

  /* v11: la ficha y las landings pueden tener varios formularios de compra (hero y bloque de compra). La barra fija móvil se
     enciende cuando el primero ya quedó arriba y NINGUNO está a la vista (antes se encendía al cargar si el formulario quedaba bajo el pliegue). */
  var pdpSticky = $('[data-pdp-sticky]'), formsAjax = $$('form[data-form-ajax]'), pdpForm = $('form[data-form-principal]') || formsAjax[0], pdpFinal = $('[data-pdp-final]');
  if (pdpFinal && pdpForm) pdpFinal.addEventListener('click', function () {
    if (pdpForm.requestSubmit) pdpForm.requestSubmit(); else pdpForm.dispatchEvent(new Event('submit', { cancelable: true }));
  });
  if (pdpSticky && pdpForm && 'IntersectionObserver' in window) {
    var formsVisibles = new Set();
    $('[data-pdp-sticky-btn]', pdpSticky).addEventListener('click', function () {
      if (pdpForm.requestSubmit) pdpForm.requestSubmit(); else pdpForm.dispatchEvent(new Event('submit', { cancelable: true }));
    });
    var actualizarPdpSticky = function () {
      var pasado = formsAjax[0].getBoundingClientRect().bottom < 0;
      var on = pasado && formsVisibles.size === 0 && matchMedia('(max-width: 899px)').matches && (!cajaCarrito || cajaCarrito.hidden);
      pdpSticky.classList.toggle('is-on', on); pdpSticky.setAttribute('aria-hidden', String(!on));
      if (on) pdpSticky.removeAttribute('inert'); else pdpSticky.setAttribute('inert', '');
      doc.style.setProperty('--sticky-h', on ? pdpSticky.offsetHeight + 'px' : '0px');
    };
    var ioForms = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) formsVisibles.add(e.target); else formsVisibles.delete(e.target); });
      actualizarPdpSticky();
    });
    formsAjax.forEach(function (f) { ioForms.observe(f); });
    addEventListener('scroll', actualizarPdpSticky, { passive: true });
  }

  /* ---------- arranque ---------- */
  montarCompra(); montarSticky();
  if (form) {
    var ini = seleccionada();
    if (ini) verFoto(ini.getAttribute('data-foto'));
    pintarSeleccion();
  }
  pintarCarrito();
  actualizarSticky();
  // Si la página quedó en caché (botón atrás), el carrito puede haber cambiado.
  addEventListener('pageshow', function (e) { if (e.persisted) refrescar().catch(function () {}); });
}());

/* Videos sin sonido · ciclo de vida común (15-oct). Sin autoplay bajo reduced-motion,
   fuera de pantalla ni en pestaña oculta. Controles manuales y cleanup del editor.
   La cinta de imágenes conserva su controlador de desplazamiento independiente. */
(function () {
  'use strict';
  var selector = 'video[data-src], video[data-hero-video]';
  if (window.DTVideos) return; // v2 es el único dueño del ciclo de vida.
  var quieto = window.matchMedia('(prefers-reduced-motion: reduce)');
  function reducido() { return (quieto.matches && document.documentElement.getAttribute('data-movimiento') !== 'forzado') && !(document.documentElement && document.documentElement.getAttribute('data-movimiento') === 'forzado'); }
  var instances = new Map();
  function iniciar(v) {
    if (instances.has(v)) return;
    var visible = false, pausadoUsuario = v.hasAttribute('data-pausado'), io = null;
    var raiz = v.closest ? v.closest('.shopify-section') : null;
    var boton = v.hasAttribute('data-hero-video') && raiz ? raiz.querySelector('[data-hero-pausa]') : null;
    var listeners = [];
    function on(target, name, fn) { target.addEventListener(name, fn); listeners.push([target, name, fn]); }
    function rotulo() {
      if (boton) { boton.setAttribute('aria-pressed', String(v.paused)); boton.setAttribute('aria-label', v.paused ? 'Reproducir el video' : 'Pausar el video'); }
    }
    function cargar() { if (!v.getAttribute('src') && v.getAttribute('data-src')) v.src = v.getAttribute('data-src'); }
    function pausar() { if (!v.paused) v.pause(); rotulo(); }
    function reproducir() {
      if (document.hidden || !visible) return;
      cargar();
      var p = v.play();
      if (p && p.catch) p.catch(function () { rotulo(); });
      rotulo();
    }
    function evaluar() {
      v.controls = false;
      if (!io || !visible || document.hidden || reducido() || pausadoUsuario) pausar();
      else reproducir();
    }
    function manual() {
      if (v.paused) { pausadoUsuario = false; v.removeAttribute('data-pausado'); reproducir(); }
      else { pausadoUsuario = true; v.setAttribute('data-pausado', ''); pausar(); }
    }
    if (boton) on(boton, 'click', manual);
    on(v, 'pause', function () { if (!document.hidden && visible && !reducido()) pausadoUsuario = true; rotulo(); });
    on(v, 'play', function () {
      if (document.hidden || !visible) { pausar(); return; }
      pausadoUsuario = false;
      rotulo();
    });
    if ('IntersectionObserver' in window) {
      io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { if (e.target === v) { visible = e.isIntersecting; evaluar(); } });
      }, { threshold: 0.35 });
      io.observe(v);
    } else {
      // Sin observador se conserva el póster y se permite reproducción manual nativa.
      visible = true; v.controls = false;
    }
    instances.set(v, {
      evaluar: evaluar,
      destruir: function () { visible = false; pausar(); if (io) io.disconnect(); listeners.forEach(function (l) { l[0].removeEventListener(l[1], l[2]); }); instances.delete(v); }
    });
    evaluar();
  }
  function todas(root, fn) {
    if (!root || !root.querySelectorAll) return;
    if (root.matches && root.matches(selector)) fn(root);
    Array.prototype.forEach.call(root.querySelectorAll(selector), fn);
  }
  function reevaluar() { instances.forEach(function (i) { i.evaluar(); }); }
  if (quieto.addEventListener) quieto.addEventListener('change', reevaluar);
  else if (quieto.addListener) quieto.addListener(reevaluar);
  document.addEventListener('visibilitychange', reevaluar);
  document.addEventListener('shopify:section:load', function (e) { todas(e.target, iniciar); });
  document.addEventListener('shopify:section:unload', function (e) { todas(e.target, function (v) { var i=instances.get(v); if(i) i.destruir(); }); });
  todas(document, iniciar);
}());

/* Menú móvil */
(function () {
  'use strict';
  var b = document.querySelector('[data-nav-btn]'), n = document.querySelector('[data-nav-movil]');
  if (!b || !n) return;
  b.addEventListener('click', function () {
    var abierto = b.getAttribute('aria-expanded') === 'true';
    b.setAttribute('aria-expanded', String(!abierto)); b.setAttribute('aria-label', abierto ? 'Abrir menú' : 'Cerrar menú');
    n.hidden = abierto;
  });
  function cerrar(foco) { if (n.hidden) return; n.hidden = true; b.setAttribute('aria-expanded', 'false'); b.setAttribute('aria-label', 'Abrir menú'); if (foco) b.focus(); }
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') cerrar(true); });
  document.addEventListener('click', function (e) { if (!n.hidden && !n.contains(e.target) && !b.contains(e.target)) cerrar(false); });
  var mq = matchMedia('(min-width: 900px)'), alCambiar = function (m) { if (m.matches) cerrar(false); };
  if (mq.addEventListener) mq.addEventListener('change', alCambiar); else if (mq.addListener) mq.addListener(alCambiar);
  Array.prototype.forEach.call(n.querySelectorAll('a'), function (a) { if (a.pathname === location.pathname) a.setAttribute('aria-current', 'page'); });
}());

/* Aparición suave al hacer scroll: el contenido es visible por defecto; solo se oculta si este script corre. */
(function () {
  'use strict';
  if (window.DTMotion) return; // Revelado v2, sin observadores duplicados.
  if (!('IntersectionObserver' in window) || (matchMedia('(prefers-reduced-motion: reduce)').matches && document.documentElement.getAttribute('data-movimiento') !== 'forzado')) return;
  var els = Array.prototype.slice.call(document.querySelectorAll('.ed__cap, .col__card, .pdp__bloque, .pdp__etiqueta, .pdp__faq, .pdp__rutina, .prob, .etq, .llega__foto, .solucion__foto, .lp-foto, .lp-hecho, .lp-compra__tarjeta, .pasos__foto, .ingr__ref'));
  if (!els.length) return;
  var alto = window.innerHeight;
  els = els.filter(function (el) { return el.getBoundingClientRect().top > alto; });  // lo que ya se ve no se oculta (sin parpadeo)
  if (!els.length) return;
  document.documentElement.classList.add('js-rv');
  els.forEach(function (el) { el.classList.add('rv'); });
  var io = new IntersectionObserver(function (es) {
    es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('rv-in'); io.unobserve(e.target); } });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
  els.forEach(function (el) { io.observe(el); });
  addEventListener('beforeprint', function () { els.forEach(function (el) { el.classList.add('rv-in'); }); });
}());

/* Franja de confianza: el botón la pausa y la reanuda (además se detiene con hover y foco, por CSS). */
(function () {
  'use strict';
  Array.prototype.forEach.call(document.querySelectorAll('[data-franja]'), function (f) {
    var b = f.querySelector('[data-franja-pausa]');
    if (!b) return;
    b.addEventListener('click', function () {
      var pausa = !f.classList.contains('is-pausa');
      f.classList.toggle('is-pausa', pausa);
      b.setAttribute('aria-pressed', String(pausa));
    });
  });
}());

/* Cinta («Así se vive»): flechas (2 tarjetas por clic, deshabilitadas en los extremos) y, si la sección lo pide (data-cinta-auto),
   desplazamiento automático lento de ida y vuelta (sin salto largo al final: llega, espera y regresa). El scroll es el del navegador:
   se puede arrastrar, deslizar o usar con teclado. Se detiene con: botón de pausa (aria-pressed), cursor encima, foco de teclado en la
   pista o las flechas, tocar/arrastrar/rueda (reanuda a los 5 s), cinta fuera de pantalla, pestaña oculta y «reducir movimiento»
   (también si cambia mientras la página está abierta). Una instancia por sección: sin doble temporizador tras shopify:section:load. */
(function () {
  'use strict';
  if (window.DTMotion) return; // La marquesina infinita v2 sustituye ida/vuelta.
  var VEL = 30, ESPERA_EXTREMO = 1400, REANUDA = 5000;  // px/s, ms, ms
  var mqQuieto = matchMedia('(prefers-reduced-motion: reduce)');
  var instancias = new Map();
  var dbg = window.__dtCinta = { activas: function () { return instancias.size; }, rafs: 0 };

  function iniciar(sec) {
    if (instancias.has(sec)) return;
    var pista = sec.querySelector('.cinta__pista'), ant = sec.querySelector('[data-cinta-ant]'), sig = sec.querySelector('[data-cinta-sig]');
    var btn = sec.querySelector('[data-cinta-pausa]');
    if (!pista) return;
    var auto = sec.hasAttribute('data-cinta-auto') && !!btn;
    var oyentes = [], timers = [], raf = 0, io = null;
    var st = { usuario: false, hover: false, foco: false, fuera: true, manualHasta: 0, holdHasta: 0, dir: 1, pos: 0, ultimo: 0 };
    function on(t, ev, fn, op) { t.addEventListener(ev, fn, op); oyentes.push([t, ev, fn, op]); }
    function quieto() { return (mqQuieto.matches && document.documentElement.getAttribute('data-movimiento') !== 'forzado'); }

    /* --- flechas --- */
    function paso() {
      var it = pista.querySelector('.cinta__item'), gap = parseFloat(getComputedStyle(pista).columnGap) || 12;
      return it ? (it.offsetWidth + gap) * 2 : pista.clientWidth * 0.8;
    }
    function mover(dir) { pista.scrollBy({ left: dir * paso(), behavior: quieto() ? 'auto' : 'smooth' }); }
    function estado() {
      if (ant && sig) {
        ant.disabled = pista.scrollLeft < 4;
        sig.disabled = pista.scrollLeft + pista.clientWidth >= pista.scrollWidth - 4;
        if (document.activeElement === ant && ant.disabled && !sig.disabled) sig.focus();
        if (document.activeElement === sig && sig.disabled && !ant.disabled) ant.focus();
      }
    }
    if (ant) on(ant, 'click', function () { mover(-1); manual(); });
    if (sig) on(sig, 'click', function () { mover(1); manual(); });
    on(pista, 'scroll', estado, { passive: true });
    on(window, 'resize', estado);
    estado();
    if (!auto) { instancias.set(sec, { destruir: destruir }); return; }

    /* --- desplazamiento automático --- */
    function debeMover() {
      return !quieto() && !st.usuario && !st.hover && !st.foco && !st.fuera && !document.hidden && Date.now() >= st.manualHasta;
    }
    function pintar() {
      var mueve = !!raf;
      sec.setAttribute('data-cinta-estado', quieto() ? 'quieto' : (mueve ? 'moviendo' : 'pausa'));
      btn.hidden = quieto();  // con «reducir movimiento» no hay nada que pausar
      btn.setAttribute('aria-pressed', String(st.usuario));
    }
    function tick(t) {
      if (!raf) return;
      if (!sec.isConnected) { destruir(); return; }
      raf = requestAnimationFrame(tick);
      var dt = st.ultimo ? Math.min(64, t - st.ultimo) / 1000 : 0;
      st.ultimo = t;
      var max = pista.scrollWidth - pista.clientWidth;
      if (max <= 4) return;
      if (Math.abs(pista.scrollLeft - st.pos) > 2.5) st.pos = pista.scrollLeft;  // el usuario movió la pista: seguir desde ahí
      if (Date.now() < st.holdHasta) return;
      st.pos += st.dir * VEL * dt;
      if (st.pos >= max) { st.pos = max; st.dir = -1; st.holdHasta = Date.now() + ESPERA_EXTREMO; }
      else if (st.pos <= 0) { st.pos = 0; st.dir = 1; st.holdHasta = Date.now() + ESPERA_EXTREMO; }
      pista.scrollLeft = st.pos;
    }
    function evaluar() {
      var si = debeMover();
      if (si && !raf) { st.ultimo = 0; st.pos = pista.scrollLeft; raf = requestAnimationFrame(tick); dbg.rafs++; }
      else if (!si && raf) { cancelAnimationFrame(raf); raf = 0; dbg.rafs--; }
      pintar();
    }
    function manual() {
      if (!auto) return;
      st.manualHasta = Date.now() + REANUDA;
      var t = setTimeout(evaluar, REANUDA + 30); timers.push(t);
      evaluar();
    }
    on(btn, 'click', function () {
      st.usuario = !st.usuario;
      if (!st.usuario) { st.manualHasta = 0; st.foco = false; }
      evaluar();
    });
    ['pointerdown', 'touchstart', 'wheel'].forEach(function (ev) { on(pista, ev, manual, { passive: true }); });
    on(pista, 'keydown', manual);
    on(pista, 'pointerenter', function (e) { if (e.pointerType === 'mouse') { st.hover = true; evaluar(); } });
    on(pista, 'pointerleave', function () { st.hover = false; evaluar(); });
    function foco(e) { var el = e.target; st.foco = !!(el && el !== btn && el.matches && el.matches(':focus-visible')); evaluar(); }
    on(sec, 'focusin', foco);
    on(sec, 'focusout', function () { st.foco = false; evaluar(); });
    on(document, 'visibilitychange', evaluar);
    if (mqQuieto.addEventListener) on(mqQuieto, 'change', evaluar); else if (mqQuieto.addListener) { mqQuieto.addListener(evaluar); oyentes.push([mqQuieto, null, evaluar]); }
    if ('IntersectionObserver' in window) {
      io = new IntersectionObserver(function (es) { st.fuera = !es[es.length - 1].isIntersecting; evaluar(); }, { threshold: 0.3 });
      io.observe(sec);
    } else { st.fuera = false; }
    evaluar();

    function destruir() {
      if (raf) { cancelAnimationFrame(raf); raf = 0; dbg.rafs--; }
      timers.forEach(clearTimeout); timers = [];
      oyentes.forEach(function (o) { if (o[1]) o[0].removeEventListener(o[1], o[2], o[3]); else if (o[0].removeListener) o[0].removeListener(o[2]); });
      oyentes = [];
      if (io) { io.disconnect(); io = null; }
      instancias.delete(sec);
    }
    instancias.set(sec, { destruir: destruir });
  }
  function destruir(sec) { var i = instancias.get(sec); if (i) i.destruir(); }
  function todas(raiz, fn) {
    if (!raiz || !raiz.querySelectorAll) return;
    if (raiz.matches && raiz.matches('[data-cinta]')) fn(raiz);
    Array.prototype.forEach.call(raiz.querySelectorAll('[data-cinta]'), fn);
  }
  todas(document, iniciar);
  document.addEventListener('shopify:section:load', function (e) { todas(e.target, iniciar); });
  document.addEventListener('shopify:section:unload', function (e) { todas(e.target, destruir); });
}());

/* Motion de marca (dt-motion, 5-oct): regla dorada bajo los antetítulos, títulos palabra por palabra, rama que se dibuja,
   regla entre los pasos y sello. Mejora progresiva: sin JS, sin IntersectionObserver o con «reducir movimiento» todo queda
   en su estado final. Lo que ya se ve al cargar no se oculta (sin parpadeo). Solo opacidad, transform, filtro y trazo: sin CLS. */
(function () {
  'use strict';
  if (!('IntersectionObserver' in window) || (matchMedia('(prefers-reduced-motion: reduce)').matches && document.documentElement.getAttribute('data-movimiento') !== 'forzado')) return;
  if (window.DTMotion) return; // v2 mantiene revelado, ramas y esferas bajo la misma política.
  var SEL = '.eye, [data-palabras], .rama, .pasos__lista, .sello-dt, .ingr__esfera, .ingr__ph';
  var io = new IntersectionObserver(function (es) {
    es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
  }, { rootMargin: '0px 0px -10% 0px', threshold: 0.15 });
  function partir(el) {  // envuelve cada palabra en <span class="w">, también dentro de <em>; los espacios quedan como texto
    var n = 0;
    (function recorrer(nodo) {
      Array.prototype.slice.call(nodo.childNodes).forEach(function (h) {
        if (h.nodeType === 1) { recorrer(h); return; }
        if (h.nodeType !== 3 || !h.textContent.trim()) return;
        var frag = document.createDocumentFragment();
        h.textContent.split(/(\s+)/).forEach(function (t) {
          if (!t) return;
          if (!t.trim()) { frag.appendChild(document.createTextNode(t)); return; }
          var w = document.createElement('span'); w.className = 'w'; w.style.setProperty('--w', n++); w.textContent = t;
          frag.appendChild(w);
        });
        nodo.replaceChild(frag, h);
      });
    })(el);
  }
  function arrancar(raiz) {
    var alto = window.innerHeight;
    Array.prototype.forEach.call((raiz || document).querySelectorAll(SEL), function (el) {
      if (el.hasAttribute('data-motion')) return;
      el.setAttribute('data-motion', '');
      if (el.classList.contains('rama')) { io.observe(el); return; }  // decoración: se dibuja aunque esté arriba del pliegue
      var r = el.getBoundingClientRect();
      if (r.top < alto && r.bottom > 0) { el.classList.add('is-in'); return; }
      if (el.hasAttribute('data-palabras') && r.top >= alto) partir(el);
      io.observe(el);
    });
    document.documentElement.classList.add('js-anim');
  }
  arrancar(document);
  document.addEventListener('shopify:section:load', function (e) { arrancar(e.target); });
  addEventListener('beforeprint', function () { Array.prototype.forEach.call(document.querySelectorAll(SEL), function (el) { el.classList.add('is-in'); }); });
}());
